// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3TFfN","productName":"Table_productName__L7dnH"};